import React from "react";
import "../../css/components/FounderSection.css";
import MattImage from "../../assets/images/MattEdwardsPlaceholder.jpg";

const FounderSection = () => (
  <div className="founder-section" id="about">
    <div
      className="founder-section-image"
      style={{ backgroundImage: `url(${MattImage})` }}
    />
    <div className="founder-section-content">
      <div className="founder-section-inner">
        <div className="founder-section-header">
          <div className="nav-regular primary">Matthew Edwards — Founder</div>
          <div className="no-gap">
            <h2 className="secondary">I served. I saw the gap.</h2>
            <h2 className="primary">I built the solution.</h2>
          </div>
        </div>
        <div className="content secondary">
          I served as a soldier in the Army — and like most service personnel, I
          quickly realised that the financial system wasn't built with us in
          mind. Advisers who didn't understand military life. Products designed
          for civilians. Guidance that arrived too late, or not at all.  So I
          built something different.
        </div>
        <div className="content secondary">
          The Plan UK exists because every rank deserves the same access to
          expert financial planning — from your first posting to your final
          pension. I know your world because I lived it. That's not a marketing
          line. That's the foundation everything here is built on.
        </div>
        <div className="founder-section-body">
          <div className="body">
            MSc Banking & International Finance BA (Hons) International Finance
            & Capital Markets FPC Financial Planning Certificate CeMap
            Certificate in Mortgage & Protection
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FounderSection;
